import PropTypes from 'prop-types'

import { DIRECTIONS } from './constants'

const basePropTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    tooltipText: PropTypes.string
}

export const spinnerBarPropTypes = {
    nextProps: PropTypes.shape(basePropTypes),
    prevProps: PropTypes.shape(basePropTypes)
}

export const spinnerButtonPropTypes = {
    direction: PropTypes.oneOf([DIRECTIONS.left, DIRECTIONS.right]),
    ...basePropTypes
}

export const spinnerButtonDefaultProps = {
    direction: DIRECTIONS.left,
    disabled: false
}
